import React from 'react';

const Content = ({children}) => {
  return <section className="content">{children}</section>;
};

export default Content;
